var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('status-select',{attrs:{"options":_vm.options,"record":_vm.record,"record_type":_vm.record_type}})}
var staticRenderFns = []

export { render, staticRenderFns }